import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// Bootstrap 3 tooltip around its children. It sits on a wrapper because a
// disabled button swallows the mouse events the tooltip needs. The page-level
// init in common.js runs before React mounts, so each wrapper initialises itself.
export default function Tooltip({
  text, as: Element = 'span', className = '', children,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    $(el).tooltip({ container: 'body' });
    return () => $(el).tooltip('destroy');
  }, []);

  return (
    <Element ref={ref} className={`tool-tip ${className}`.trim()} data-original-title={text}>
      {children}
    </Element>
  );
}

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  as: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
